export default __webpack_public_path__ + "static/media/etapa4.c2a92efa.png";